import { customElement, FASTElement, observable, attr } from '@microsoft/fast-element';
import { MultiSelectTemplate as template } from './multi-select.template';
import { MultiSelectStyles as styles } from './multi-select.styles';

const name = 'cascade-multi-select';

export interface IMultiSelectOption {
  CHECKED: boolean;
  ITEM_ID: string;
  ITEM_DESC: string;
  DISABLED: boolean;
  CATEGORY: string;
}

@customElement({
  name,
  template,
  styles,
})
export class MultiSelect extends FASTElement {
  @observable isItemListVisible: boolean = false;
  @observable keyValues: string[] = [];
  @observable selectedIds: string[] = [];
  @attr label: string = '';
  @attr clearOnBlur: boolean = false;
  @observable isDisabled: boolean = false;
  @attr disabled: boolean = false;
  @observable dataList: IMultiSelectOption[] = [];
  @attr dataListAttr: IMultiSelectOption[] = [];
  @observable dataSearchList: IMultiSelectOption[] = [];
  @observable itemSearch: string = '';
  @observable selectedItemsText: string = '';
  @attr isPositionRelative: boolean = false;

  @observable listBoxElement!: HTMLDivElement;

  public connectedCallback() {
    super.connectedCallback();
  }

  setItemListVisible(value: boolean) {
    this.isItemListVisible = value;
    if (!this.isItemListVisible) {
      this.dataSearchList = this.dataList
        .sort((a, b) => Number(b.CHECKED) - Number(a.CHECKED))
        .slice();
      this.itemSearch = '';
    }
  }

  setItemListVisibleButton(value: boolean) {
    setTimeout(() => {
      this.setItemListVisible(value);
    }, 100);
  }

  onItemSearch(value: string) {
    this.dataSearchList = [
      ...this.dataList
        .filter(
          (item) =>
            item.ITEM_DESC.toLocaleLowerCase().includes(value.toLocaleLowerCase()) ||
            (item.CATEGORY &&
              item.CATEGORY.toLocaleLowerCase().includes(value.toLocaleLowerCase())),
        )
        .sort((a, b) => Number(b.CHECKED) - Number(a.CHECKED))
        .slice(),
    ];
  }

  itemSelected(id: string) {
    const item = this.dataList.find((element) => element.ITEM_ID === id);
    if (item) {
      item.CHECKED = !item.CHECKED;
    }
    this.selectedIds = this.getSelectedIds();
    this.updateSelectedItemsText();
    this.isItemListVisible = true;
    this.focus();
  }

  public disableVisibility(e: FocusEvent): boolean | void {
    this.isItemListVisible = false;

    this.clearSearch();
  }

  public setDataList(dataList: IMultiSelectOption[]) {
    this.clearSearch();
    this.dataList = [];
    this.dataSearchList = [];
    this.selectedIds = [];
    this.isItemListVisible = false;
    this.dataList = dataList
        .sort((a, b) => {
          return Number(b.CHECKED) - Number(a.CHECKED);
        })
        .slice();
    this.dataSearchList = [...this.dataList.slice()];

    this.updateSelectedItemsText();
    this.selectedIds = this.getSelectedIds();
  }

  public dataListAttrChanged(oldValue, newValue) {
    this.setDataList(newValue ? newValue.slice() : []);
  }

  public getSelectedIds(): string[] {
    if (this.isDisabled) {
      return [];
    }
    const idList: string[] = this.dataList
      .filter((element) => element?.CHECKED)
      .map((element) => element.ITEM_ID);
    return idList;
  }

  public clearSearch() {
    this.isItemListVisible = false;
    this.dataSearchList = this.dataList
      .sort((a, b) => Number(b.CHECKED) - Number(a.CHECKED))
      .slice();
    this.itemSearch = '';
  }

  public checkFilteredList() {
    if (this.clearOnBlur) {
      if (this.dataSearchList.length === 0) {
        this.clearSearch();
      }
    }
  }

  private updateSelectedItemsText() {
    this.selectedItemsText = this.getSelectedIds().length + ' values selected';
  }
}

export const getCheckBoxValue = (element: IMultiSelectOption) => {
  if (element.CATEGORY && element.CATEGORY != '') {
    return (
      '' + element.ITEM_DESC + "<span style='font-weight:bold'> (" + element.CATEGORY + ' ) </span>'
    );
  }
  return element.ITEM_DESC;
};
